import { useCallback } from "react";
import { graphql, useMutation, UseMutationConfig } from "react-relay";
import { useAddNotePageMutation } from "./__generated__/useAddNotePageMutation.graphql";

export function useNoteAddPage() {
  const [addPage, isInFlight] = useMutation<useAddNotePageMutation>(
    graphql`
      mutation useAddNotePageMutation($widgetId: ID!, $atIndex: Int!) {
        note(id: $widgetId) {
          pageCreate(atIndex: $atIndex) {
            id
            pages {
              id
            }

            ...NoteNative_note
          }
        }
      }
    `
  );

  const onAddPage = useCallback(
    (
      widgetId: string,
      atIndex: number,
      onCompleted: UseMutationConfig<useAddNotePageMutation>["onCompleted"]
    ) => {
      addPage({
        onCompleted,
        variables: {
          widgetId,
          atIndex,
        },
      });
    },
    [addPage]
  );

  return [onAddPage, isInFlight] as const;
}
